import { Modal } from '../ui/Modal';
import { AlertTriangle } from 'lucide-react';

interface Props {
  title: string;
  message: string;
  onConfirm: () => void;
  onClose: () => void;
  danger?: boolean;
}

export function ConfirmDialog({ title, message, onConfirm, onClose, danger }: Props) {
  return (
    <Modal open onClose={onClose} title={title} size="sm"
      footer={<>
        <button className="btn-ghost" onClick={onClose}>Отмена</button>
        <button className={danger ? 'btn-danger' : 'btn-primary'} onClick={onConfirm} autoFocus>
          {danger ? 'Удалить' : 'Подтвердить'}
        </button>
      </>}>
      <div className="flex gap-3">
        {danger && (
          <div className="w-9 h-9 rounded-full bg-status-refused/10 grid place-items-center flex-shrink-0">
            <AlertTriangle className="w-5 h-5 text-status-refused" />
          </div>
        )}
        <p className="text-sm text-ink-2 leading-relaxed">{message}</p>
      </div>
    </Modal>
  );
}
